import isObject from "./component-library116.mjs";
import InputWrapper from "./component-library17.mjs";
import LabeledInput from "./component-library16.mjs";
import "./component-library117.mjs";
import normalizeComponent from "./component-library81.mjs";
const _sfc_main = {
  components: { InputWrapper },
  mixins: [LabeledInput],
  props: {
    value: {
      type: [Array, Number, String],
      default: () => []
    },
    promptValue: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      required: true
    },
    prompt: {
      type: String,
      default: null
    },
    selectClass: {
      type: [Array, String, Object],
      default: null
    },
    hidePrompt: { type: Boolean },
    autocomplete: { type: String, default: null },
    name: { type: String, default: null }
  },
  emits: ["select", "input"],
  computed: {
    inputOrCustomInputClass() {
      if (this.selectClass)
        return this.selectClass;
      return this.inputClass;
    },
    sanitizedOptions() {
      return this.options.map((option) => {
        if (isObject(option))
          return option;
        return { label: option, value: option };
      });
    }
  },
  methods: {
    onInput(event) {
      const { value } = event.target;
      const selection = this.sanitizedOptions.find((option) => option.value === value);
      this.$emit("input", value);
      this.$emit("select", selection);
    }
  }
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  return _c("InputWrapper", _vm._b({ scopedSlots: _vm._u([{ key: "default", fn: function({ id }) {
    return [_c("select", _vm._b({ staticClass: "input-wrapper__input selectbox", class: _vm.inputOrCustomInputClass, attrs: { "id": id, "autocomplete": _vm.autocomplete }, on: { "change": _vm.onInput } }, "select", _vm.inputFiledProps, false), [!_vm.hidePrompt ? _c("option", { domProps: { "selected": _vm.promptValue === _vm.value, "value": _vm.promptValue } }, [_vm._v(" " + _vm._s(_vm.prompt) + " ")]) : _vm._e(), _vm._l(_vm.sanitizedOptions, function(option) {
      return _c("option", { key: option.value, domProps: { "selected": option.value === _vm.value, "value": option.value } }, [_vm._v(" " + _vm._s(option.label) + " ")]);
    })], 2)];
  } }]) }, "InputWrapper", _vm.inputWrapperProps, false));
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "4ac9ff66",
  null,
  null
);
const SelectInput = __component__.exports;
export {
  SelectInput as default
};
